import * as type from '../constants/firmware'

export const saveAvailableFirmwares = firmwares => ({
  type: type.SAVE_AVAILABLE_FIRMWARES,
  firmwares,
})

export const updateFirmware = data => ({
  type: type.UPDATE_FIRMWARE_CHANNEL,
  data,
})

export const syncFirmware = () => ({
  type: type.SYNC_FIRMWARE_CHANNEL,
})

export const syncSentFirmware = () => ({
  type: type.SYNC_SENT_FIRMWARE_CHANNEL,
})

export const syncDoneFirmware = () => ({
  type: type.SYNC_DONE_FIRMWARE_CHANNEL,
})

export const setFirmwareForUpdate = pickedFirmware => ({
  type: type.SET_FIRMWARE_FOR_UPDATE,
  pickedFirmware,
})

export const startFirmwareUpdate = () => ({
  type: type.START_FIRMWARE_UPDATE,
})

export const setFirmwareStatus = status => ({
  type: type.SET_FIRMWARE_STATUS,
  status,
})

export const resetFirmwareStatus = () => ({
  type: type.RESET_FIRMWARE_STATUS,
})
